import React from 'react';

import { COLORS } from "../../utils/Colors";

interface AppLayoutProps {
    aside: React.ReactNode;
    header: React.ReactNode;
    main: React.ReactNode;
    isSidebarOpen: boolean;
}

const AppLayout: React.FC<AppLayoutProps> = ({ aside, header, main, isSidebarOpen }) => {
    return (
        <article className="h-screen flex">
            <aside className={`fixed top-0 bottom-0 w-84 flex-col text-white font-bold border-r border-app-border z-40
            transition-all duration-300 border-app-border shadow-lg ${isSidebarOpen ? 'flex' : 'hidden'} flex-col`}
            style={{ background: COLORS.Brand }}>
                {aside}
            </aside>
            <section className="">
                <header className="fixed w-full top-0 h-[4rem] bg-transparent z-30">
                  <div className="w-full h-full flex items-center justify-start py-6 px-4 md:px-16">
                    {header}
                  </div>
                </header>
                <main className="overflow-y-auto scrollbar-hide">
                    {main}
                </main>
            </section>
        </article>
    );
};

export default AppLayout;